export type CartItem = {
  productId: number;
  slug: string;
  title: string;
  image?: string;
  sku?: string;
  variantId?: number;
  price: number;
  quantity: number;
};

const key = "commerce_cart";

export function getCart(): CartItem[] {
  try {
    return JSON.parse(localStorage.getItem(key) || "[]");
  } catch {
    return [];
  }
}

export function saveCart(items: CartItem[]) {
  localStorage.setItem(key, JSON.stringify(items));
  window.dispatchEvent(new Event("cart:changed"));
}

export function addToCart(item: CartItem) {
  const items = getCart();
  const index = items.findIndex((row) => row.productId === item.productId && row.variantId === item.variantId);
  if (index >= 0) items[index].quantity += item.quantity;
  else items.push(item);
  saveCart(items);
}

export function cartTotal(items = getCart()) {
  return items.reduce((sum, item) => sum + item.price * item.quantity, 0);
}
